import PropTypes from 'prop-types';
import React from 'react';

import ContainerLink from 'samples/containers/ContainerLink';

interface OptionalContainerLinkProps {
  containerId?: string;
}

export default function OptionalContainerLink(props: OptionalContainerLinkProps): JSX.Element {
  if (props.containerId) {
    return <ContainerLink containerId={props.containerId} />;
  } else {
    return <span className="u-italic">Not selected</span>;
  }
}
OptionalContainerLink.propTypes = {
  containerId: PropTypes.string,
};
